export const watch = {
  authUser(value) {
    this.checkForUser(value)
  },
  hoaId() {
    this.reload()
  },
  async toggle() {
    if (this.toggle == false) {
      this.toggle = false
      if (this.Modal && this.Modal != undefined) {
        this.Modal.$emit('update:toggle', (this.toggle = false))
      }
    }
  }
}
